export const FIREBASE_PROJECT_ID_PATTERN = "[a-z](?:[a-z0-9]|-){4,29}";
